<script setup lang="ts">
import { useSystemStore } from '@/stores/systemStore.ts';

const systemStore = useSystemStore();
</script>

<template>
  <div v-if="systemStore.maintenanceModeInfo" class="maintenance-mode">
    <div class="text-body-1">
      <span class="caption">{{ $t('Maintenance') }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.maintenance-mode {
  display: flex;
  color: rgb(var(--v-theme-off-white));
  background-color: rgb(var(--v-theme-warning-darken-1));
  align-items: center;
  justify-content: center;
}
.caption {
  font-weight: 600;
  vertical-align: center;
}
</style>
